function fillBankingGlobalDate() {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const d = new Date();
    const day = String(d.getDate()).padStart(2, '0');
    const dateStr = `${months[d.getMonth()]} ${day}, ${d.getFullYear()}`;
    document.querySelectorAll('.js-banking-global-date').forEach((el) => {
        el.textContent = dateStr;
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fillBankingGlobalDate);
} else {
    fillBankingGlobalDate();
}
